import { Attributes, Rules, Validation } from '@singularsystems/neo-core';
import TemporalEntity from '../TemporalEntity';

export default class PortalTermsAndConditions extends TemporalEntity {
    static typeName = "PortalTermsAndConditions";

    constructor() {
        super();
        this.makeObservable();
    }

    public portalTermsAndConditionsId: number = 0;

    @Rules.Required()
    @Attributes.Date()
    public effectiveOn: Date | null = null;

    public htmlContent: string = "";

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<PortalTermsAndConditions>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Terms and Conditions";
    }
}